/*
    This store is used on form wizard, hierarchical menu and other similar places
    where we might be using same template/object at multiple steps.
    so instead of calling backend multiple times use this store which keeps a map of
    templates required values.
*/
export * from './actions';
export * from './mutations';
export * from './state';

export const namespaced = true;
